module.exports = __webpack_public_path__ + "assets/pdf/vino-blanco.63f91985.pdf";